import { render, staticRenderFns } from "./PerformanceSeal.vue?vue&type=template&id=418db68f"
import script from "./PerformanceSeal.vue?vue&type=script&lang=js"
export * from "./PerformanceSeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports